import { X } from "lucide-react";

export const Modal = ({ open, onClose, title, children, footer, testid }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-ink/40 px-4 py-10"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      data-testid={testid || "modal-overlay"}
    >
      <div className="w-full max-w-lg bg-paper border border-hairline shadow-sm animate-fade-up">
        <div className="flex items-center justify-between border-b border-hairline px-6 py-4">
          <h3 className="font-serif text-2xl text-ink leading-none">{title}</h3>
          <button
            onClick={onClose}
            className="text-stone hover:text-ink transition-colors"
            data-testid="modal-close"
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </div>
        <div className="px-6 py-5">{children}</div>
        {footer && <div className="flex justify-end gap-3 border-t border-hairline px-6 py-4">{footer}</div>}
      </div>
    </div>
  );
};
